export default "__VITE_ASSET__3MTtE9kq__"